import { render, staticRenderFns } from "./input_box.vue?vue&type=template&id=21ecbac6&"
import script from "./input_box.vue?vue&type=script&lang=js&"
export * from "./input_box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VIcon,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4011163442/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21ecbac6')) {
      api.createRecord('21ecbac6', component.options)
    } else {
      api.reload('21ecbac6', component.options)
    }
    module.hot.accept("./input_box.vue?vue&type=template&id=21ecbac6&", function () {
      api.rerender('21ecbac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parties/form/input_box.vue"
export default component.exports